import React from "react";
import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { CacheProvider } from "@emotion/react";

import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import "./i18n";
import createTheme from "./theme";
import routes from "./routes";

import useTheme from "./hooks/useTheme";
import { store } from "./redux/store";
import createEmotionCache from "./utils/createEmotionCache";

import { AuthProvider } from "./contexts/FirebaseAuthContext";
import { ConfirmProvider } from "./contexts/ConfirmContext";

const clientSideEmotionCache = createEmotionCache();

function App({ emotionCache = clientSideEmotionCache }) {
  const content = useRoutes(routes);

  const { theme } = useTheme();

  return (
    <CacheProvider value={emotionCache}>
      <HelmetProvider>
        <Helmet
          titleTemplate="%s | Gulf-Pro"
          defaultTitle="Gulf-Pro Admin Dashboard"
        />
        <MuiThemeProvider theme={createTheme(theme)}>
          <ConfirmProvider>
            <Provider store={store}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <AuthProvider>{content}</AuthProvider>
              </LocalizationProvider>
            </Provider>
          </ConfirmProvider>
        </MuiThemeProvider>
      </HelmetProvider>
    </CacheProvider>
  );
}

export default App;
